import { useCallback, useEffect, useState } from "react";
import { useSocial, useLogin } from "./hooks";
import useTA from '@/utils/useTA';
import { useInterval } from "ahooks";
import React from "react";

type Driver = 'facebook' | 'google' | 'apple' | 'huawei' | 'wechat' | 'wechat_web' | 'qq' | 'line'

interface Props {
  children: any;
  type: Driver;
  scene: string;
  allowClick: boolean;
  onSuccess: (val: string) => void;
  onForbiddenClick?: () => void;
}

export const isInFacebookWebView = () => {
  return /(FBAN|FBAV)\/\w+/.test(navigator.userAgent)
}

const LoginBtn = ({type, children, onSuccess, allowClick, onForbiddenClick, scene}: Props) => {
  const { url, getSocial, state, checkAuth } = useSocial();
  const { loginSocial } = useLogin();
  const { reportTrack } = useTA();
  const [delay, setDelay] = useState<number | undefined>(undefined);
  const [ windowObj, setWindowObj ] = useState<Window>()

  const jumpLogin = () => {
    try {
      if (windowObj) {
        windowObj.location.href = url;
        setDelay(2000);
      } else {
        window.localStorage.setItem('redirect_url', JSON.stringify(window.location.href));
        window.localStorage.setItem('login_type', JSON.stringify(type));
        window.localStorage.setItem('login_scene', JSON.stringify(scene));
        window.localStorage.setItem('login_state', JSON.stringify(state));
        window.location.href = url;
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleClickLogin = () => {
    // 判断是否能够点击
    if(!allowClick && onForbiddenClick) {
      onForbiddenClick()
      return
    }
    getSocial(type, scene);
    // return
    try {
      const log = type.charAt(0).toUpperCase() + type.slice(1);
      reportTrack(log);
    } catch (err) {}


    if (isInFacebookWebView()) {
      return;
    }
    try {
      const a = window.open('about:blank', '_blank')
      if(a && a.location.href == 'about:blank') {
        setWindowObj(a)
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if(url) {
      jumpLogin()
    }
  }, [url])

  useInterval(async () => {
    try {
      const res = await checkAuth(type, scene)
      if(res.code === 0) {
        if(windowObj) {
          windowObj.close()
        }
        setDelay(undefined)
        if(res?.data?.code) {
          loginSocial({type, code: res.data.code, onSuccess});
        }
      }
      
    } catch (error) {
      console.log(error)
    }
    
  }, delay);

  return <div onClick={handleClickLogin}>
    {children}
  </div>
}

export default LoginBtn